module.exports = __webpack_public_path__ + "static/media/ReadyForClosing.2fedd3f3.svg";